document.addEventListener("DOMContentLoaded", function () {
  const allPopupSignin = document.querySelectorAll("button[data-vari-id]");
  if (allPopupSignin) {
    Array.from(allPopupSignin).forEach((popupSignin) => {
      popupSignin.addEventListener("click", function (e) {
        e.preventDefault();

        e.target.classList.add("loading");
        e.target.disabled = true;

        Array.from(
          document.querySelectorAll(".subscribe-recharge-button")
        ).forEach((bbb) => {
          bbb.disabled = true;
          bbb.innerHTML = "Only one class per Roomie";
        });
        const variId = popupSignin.getAttribute("data-vari-id");

        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        const sectionz = this.cart
          .getSectionsToRender()
          .map((section) => section.id);
        // fetch api to add to cart
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: variId,
            quantity: 1,
            sections: sectionz,
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            e.target.innerHTML = "Your spot is reserved!";
            this.cart.renderContents(response);
          });
      });
    });
  }
});
